// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	//const [loaded, setLoaded] = React.useState(false);
	//const [types, setTypes] = React.useState([]);
	//const [changed, setChanged] = React.useState(false);
	//const [saveLabel, setSaveLabel] = React.useState('Save');
	const basicvars = ['itswidth', 'itsheight'];
	const [basic, setBasic] = React.useState({
		itswidth : 4,
		itsheight : 2
	});
	
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			var bds = {};
			basicvars.forEach((bd) => bds[bd] = sign[bd]);
			setBasic(bds);
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	/*
	const getTypes = () =>{
		setLoaded(true);
		handleSend({
			vso: 'typeslist'
		}, (data) => {
			console.log(data);
			setTypes(data.types);
			//setBTypesList(data.btypes);
			//setCategories(data.categories);
			//setImages(data.images);
		});
	};
	*/
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, basic);
		let ovalue = name === 'itswidth' ? basic.itsheight : basic.itswidth;
		
		//if numeric
		
		//if([
		//	'opt_height', 
		//	'opt_width',
		//	'opt_digits'
		 //  ].indexOf(name) !== -1){
		value = parseInt(value);
			//clean the value
		if(isNaN(value) || value < 0){
			value = 1;
		} else if(value * (ovalue ? ovalue : 1) > 256){
			value = Math.floor(256 / (ovalue ? ovalue : 1))
		}
		
		
		newDetails[name] = value;
		setBasic(newDetails);
		if(onChange){
			console.log('somethings changed!');
			onChange(newDetails);
		}
		//setChanged(true);
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title="Size" />
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_its_width"
							name="itswidth"
							label="Width"
							value={basic.itswidth}
							type="number"
							inputProps = {{
									  min: "1",
									  max: Math.floor(256 / (basic.itsheight ? basic.itsheight : 1))
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_its_height"
							name="itsheight"
							label="Height"
							type="number"
							value={basic.itsheight}
							onChange={handleChangeValue}
							inputProps = {{
								min: "1", 
								max: Math.floor(256 / (basic.itswidth ? basic.itswidth : 1))
							}}
							fullWidth
						/>
					</Grid>
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
